import {Component} from '@angular/core';
import {InternalProjectDetailComponent} from './internal-project-detail.component';
import {InternalProjectListComponent} from './internal-project-list.component';



@Component({
    selector: 'app-internal-project',
    templateUrl: './internal-project.component.html',
    imports: [
        InternalProjectDetailComponent,
        InternalProjectListComponent
    ],
    styleUrls: ['./internal-project.component.scss']
})
export class InternalProjectComponent {

}
